/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import {Button, FormCheck} from 'react-bootstrap';
import State from './State';
import FormGroup from '../../../../components/FormGroup';
import FormControl from '../../../../components/FormControl';
import PasswordField from '../../../../components/PasswordField';

class Credentials extends React.Component<Props, State> {

	static defaultProps: Props = {
		onAccountNameChange: () => {
			// do nothing
		},
		onPasswordChange: () => {
			// do nothing
		},
		onResetPasswordClick: () => {
			// do nothing
		},
		onSubmitCredentials: () => {
			// do nothing
		},
		submitDisabled: false,
		violations: {}
	};

	constructor(props: Props) {
		super(props);

		this.state = {accountName: '', password: '', rememberMe: true};
	}

	handleAccountNameChange = (event: React.FormEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>): void => {
		const props: Readonly<Props> = this.props;

		this.setState({accountName: String(event.currentTarget.value).trim()}, () => props.onAccountNameChange());
	};

	handlePasswordChange = (password: string): void => {
		const props: Readonly<Props> = this.props;

		this.setState({password}, () => props.onPasswordChange());
	};

	handleRememberMeChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
		this.setState({rememberMe: Boolean(event.currentTarget.checked)});
	};

	handleSubmitCredentials = (): void => {
		const props: Readonly<Props> = this.props;

		if (!props.submitDisabled)
			props.onSubmitCredentials(this.state.accountName, this.state.password, this.state.rememberMe);
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		return (
			<React.Fragment>
				<FormGroup controlId="email" label="E-mail:" violations={props.violations.accountName}>
					<FormControl
						type="email"
						name="email"
						autoComplete="username email"
						autoFocus={true}
						placeholder="E-mail"
						value={state.accountName}
						isInvalid={(props.violations.accountName || []).length > 0}
						onChange={this.handleAccountNameChange}
						onEnter={this.handleSubmitCredentials}/>
				</FormGroup>
				<PasswordField
					autoComplete={'current-password'}
					autoFocus={false}
					onChange={this.handlePasswordChange}
					onEnter={this.handleSubmitCredentials}
					password={state.password}
					violations={props.violations.password}/>
				<FormCheck
					type="checkbox"
					checked={state.rememberMe}
					onChange={this.handleRememberMeChange}
					label="Onthoud mij"
				/>
				<Button
					type="submit"
					className="float-end"
					variant="primary"
					onClick={this.handleSubmitCredentials}
					disabled={props.submitDisabled}>
					{'Inloggen'}
				</Button>
				<Button
					type="button"
					className="float-start"
					variant="link"
					onClick={props.onResetPasswordClick}>
					{'Wachtwoord vergeten?'}
				</Button>
			</React.Fragment>
		);
	}
}

export default Credentials;
